import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AdminCoursesComponent } from './admin-courses.component';
import { AdminSubjectsComponent } from './admin-subjects.component';
import { AdminTopicsComponent } from './admin-topics.component';
import { AdminAreasComponent } from './admin-areas.component';
import { AdminQuestionsComponent } from './admin-questions.component';

@Component({
  selector: 'app-admin-content',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    AdminCoursesComponent,
    AdminSubjectsComponent,
    AdminTopicsComponent,
    AdminAreasComponent,
    AdminQuestionsComponent
  ],
  templateUrl: './admin-content.component.html',
  styleUrl: './admin-layout.css'
})
export class AdminContentComponent {
  activeTab: 'courses' | 'subjects' | 'topics' | 'areas' | 'questions' = 'courses';

  setTab(tab: typeof this.activeTab) {
    this.activeTab = tab;
  }
}
